import { toast } from 'sonner';
import { API } from '../../config/api';
import { DataService } from '../../config/dataService/dataService';
import { paramsToQueryString } from '../../utility/helpers/commonFunction';

export const getSavedServiceApi = (savedServiceParams) => {
    return async (dispatch) => {
        try {
            let queryString = '?';

            // Add other single value params
            if (savedServiceParams.search) {
                queryString += `&search=${encodeURIComponent(savedServiceParams.search)}`;
            }
            // Add array params for customer
            if (savedServiceParams.serviceCategory && savedServiceParams.serviceCategory.length > 0) {
                savedServiceParams.serviceCategory.forEach((serviceId) => {
                    queryString += `&serviceCategory=${serviceId}`;
                });
            }

            // Add array params for company
            if (savedServiceParams.vehicleMake && savedServiceParams.vehicleMake.length > 0) {
                savedServiceParams.vehicleMake.forEach((vehicleId) => {
                    queryString += `&vehicleMake=${vehicleId}`;
                });
            }

            // Add pagination params
            queryString += `&pagination=true`;
            queryString += `&page=${savedServiceParams.page}`;
            queryString += `&limit=${savedServiceParams.limit}`;
            queryString += `&sortBy=${savedServiceParams.sortBy}`;
            queryString += `&sortOrder=${savedServiceParams.sortOrder}`;

            queryString.startsWith('&') ? queryString.substring(1) : queryString;

            const response = await DataService.get(API.savedService.getList + queryString);
            if (!response.data.error) {
                dispatch({
                    type: API.savedService.getList,
                    savedServiceList: response.data,
                });
                return response.data;
            } else {
                return false;
            }
        } catch (error) {
            console.log('🚀 ~ getSavedServiceApi ~ error:', error);
            return false;
        }
    };
};

export const getSavedServiceDetailApi = (id) => {
    return async (dispatch) => {
        try {
            const response = await DataService.get(API.savedService.getDetail + id);
            if (response.data.status) {
                return response.data.data;
            } else {
                return false;
            }
        } catch {
            return false;
        }
    };
};

export const checkSavedServiceExistance = (params) => {
    return async (dispatch) => {
        try {
            const response = await DataService.post(API.savedService.check, params);
            if (response.data.status) {
                return response.data.data;
            } else {
                return false;
            }
        } catch {
            return false;
        }
    };
};

// not working proeprly
export const checkServiceExistance = (id) => {
    return async (dispatch) => {
        try {
            console.log('🚀 ~ checkServiceExistance ~ id:', id);
            const response = await DataService.get(API.savedService.check + id);
            console.log('🚀 ~ return ~ response:', response);
            if (!response.data.error) {
                return response.data.data;
            } else {
                return false;
            }
        } catch {
            return false;
        }
    };
};

export const getGroupedSavedServiceApi = (params) => {
    return async (dispatch) => {
        try {
            let queryString = paramsToQueryString(params);
            const response = await DataService.get(API.savedService.groupList + queryString);
            if (!response.data.error) {
                dispatch({
                    type: API.savedService.groupList,
                    groupedServiceList: response.data,
                });
                return response.data;
            } else {
                return false;
            }
        } catch {
            return false;
        }
    };
};

export const addSavedServiceApi = async (payload) => {
    try {
        const response = await DataService.post(API.savedService.create, payload);
        if (response.data.status) {
            toast.success(response?.data?.message);
            return response.data;
        } else {
            return false;
        }
    } catch (error) {
        console.log('🚀 ~ addSavedServiceApi ~ error:', error);
        return false;
    }
};

export const updateSavedServiceApi = async (id, payload) => {
    try {
        const response = await DataService.put(API.savedService.update + id, payload);
        if (response.data.status) {
            toast.success(response?.data?.message);
            return response.data;
        } else {
            return false;
        }
    } catch (error) {
        console.log('🚀 ~ updateSavedServiceApi ~ error:', error);
        return false;
    }
};

export const updateSavedServiceFromCategoryApi = async (id, payload) => {
    try {
        const response = await DataService.put(API.savedService.categoryUpdate + id, payload);
        if (!response.data.error) {
            toast.success(response?.data?.message);
            return response.data;
        } else {
            return false;
        }
    } catch {
        return false;
    }
};

export const deleteSavedServiceApi = async (id) => {
    try {
        const response = await DataService.delete(API.savedService.delete + id);
        if (response.data.status) {
            toast.success(response?.data?.message);
            return true;
        } else {
            return false;
        }
    } catch {
        return false;
    }
};
